import { ReactRouterAddonStoryParameters } from '../../components/ReactRouterDecorator';

export function reactRouterParameters(params: ReactRouterAddonStoryParameters) {
  return params;
}
